'use client';

import { Trans } from 'react-i18next';
import { Accordion, AccordionGroup } from 'ui';

import { useTranslation } from '@/i18n/client';

import styles from './PaymentsAccordions.module.scss';

export const PaymentsAccordions = () => {
  const { t } = useTranslation(['faq']);

  return (
    <AccordionGroup>
      <Accordion heading={t('faq.collectPaymentQuestion')}>
        <div className={styles.paymentsAccordions__accordionContent}>
          <p>{t('faq.collectPaymentAnswer')}</p>
        </div>
      </Accordion>
      <Accordion heading={t('faq.canICancelQuestion')}>
        <div className={styles.paymentsAccordions__accordionContent}>
          <p>{t('faq.canICancelAnswer1')}</p>
          <p>{t('faq.canICancelAnswer2')}</p>
        </div>
      </Accordion>
      <Accordion heading={t('faq.invoiceInfoChangeQuestion')}>
        <div className={styles.paymentsAccordions__accordionContent}>
          <p>{t('faq.invoiceInfoChangeAnswer1')}</p>
          <p>{t('faq.invoiceInfoChangeAnswer2')}</p>
        </div>
      </Accordion>
      <Accordion heading={t('faq.bankAccountQuestion')}>
        <div className={styles.paymentsAccordions__accordionContent}>
          <p>{t('faq.bankAccountAnswer1')}</p>
          <p>{t('faq.bankAccountAnswer2')}</p>
          <p>
            <Trans
              i18nKey="faq.bankAccountAnswer3"
              t={t}
              components={[<br key={0} />]}
            />
          </p>
        </div>
      </Accordion>
    </AccordionGroup>
  );
};
